module.exports = __webpack_public_path__ + "teqbahn-assets/media/Slide1bg.15de5d15.mp4";